import React from "react";
import { connect } from "react-redux";

import Button from "components/Button";
import {
  StyledForm,
  FormGroup,
  FieldHead,
  ChannelFormSection,
  SharingRequiredField,
  UpgradeText,
  UpgradeButtonLink,
  UpgradeButtonLinkContainer,
} from "./styledComponents";
import { ToastContainer, toast } from "react-toastify";
import { Field, formValueSelector, change } from "redux-form";
import Divider from "components/Divider";

import { SharingFormField } from "./components";
const notify = () => toast("Changes Saved!");

const formOptions = [
  {
    header: "Lead Data Capture",
    eligibleTiers: ["plus", "pro", "super_admin"],
    description:
      "Collect additional lead data when someone shares their images from the iPad app.",

    fields: [
      {
        name: "first_name_enabled",
        label: "first name",
        description: "Enable first name collection",
        requiredName: "first_name_required",
        eligibleToCollect: ["plus", "pro", "super_admin", "enterprise_admin"],
        eligibleToRequireTiers: [
          "plus",
          "pro",
          "super_admin",
          "enterprise_admin",
        ],
      },
      {
        name: "last_name_enabled",
        label: "last name",
        description: "Enable last name collection",
        requiredName: "last_name_required",
        eligibleToCollect: ["plus", "pro", "super_admin", "enterprise_admin"],
        eligibleToRequireTiers: [
          "plus",
          "pro",
          "super_admin",
          "enterprise_admin",
        ],
      },
      {
        name: "date_of_birth_enabled",
        label: "date of birth",
        description: "Enable date of birth collection",
        requiredName: "date_of_birth_required",
        eligibleToCollect: ["pro", "super_admin", "enterprise_admin"],
        eligibleToRequireTiers: ["pro", "super_admin", "enterprise_admin"],
      },
      {
        name: "zip_code_enabled",
        label: "zip code",
        description: "Enable ZIP code collection",
        requiredName: "zip_code_required",
        eligibleToCollect: ["pro", "super_admin", "enterprise_admin"],
        eligibleToRequireTiers: ["pro", "super_admin", "enterprise_admin"],
      },
    ],
  },
  {
    header: "Sharing from the App",
    description: `Configure how you'd like to enable guests to share their images from the iPad app.`,
    eligibleTiers: ["lite", "plus", "pro", "super_admin", "enterprise_admin"],
    fields: [
      {
        name: "email_enabled",
        label: "email sharing",
        description: "Enable sharing by email",
        requiredName: "email_required",
        eligibleToRequireTiers: [
          "plus",
          "pro",
          "super_admin",
          "enterprise_admin",
        ],
      },
      {
        name: "phone_enabled",
        label: "text message sharing",
        description: "Enable sharing by text message",
        requiredName: "phone_required",
        eligibleToRequireTiers: [
          "plus",
          "pro",
          "super_admin",
          "enterprise_admin",
        ],
      },
      {
        name: "twitter_enabled",
        label: "twitter sharing",
        description: "Enable sharing by Twitter",
        requiredName: "twitter_required",
        eligibleToRequireTiers: [
          "plus",
          "pro",
          "super_admin",
          "enterprise_admin",
        ],
      },
    ],
  },
  {
    header: "Sharing from the Online Gallery",
    description: `Configure how you'd like to enable guests to share their images from the online gallery.`,
    eligibleTiers: ["lite", "plus", "pro", "super_admin", "enterprise_admin"],
    fields: [
      {
        name: "gallery_email_enabled",
        label: "email sharing",
        description: "Enable sharing by email",
      },
      {
        name: "gallery_phone_enabled",
        label: "text message sharing",
        description: "Enable sharing by text message",
      },
      {
        name: "gallery_twitter_enabled",
        label: "twitter sharing",
        description: "Enable sharing by Twitter",
      },
      {
        name: "gallery_facebook_enabled",
        label: "facebook sharing",
        description: "Enable sharing by Facebook",
      },
    ],
  },
];

const getFieldValue = (data, fieldName) => {
  if (!data) return false;
  var parts = fieldName.split("_");
  const valuePart = parts.pop();
  const value = data.find(
    (x) =>
      x.name.replace("_", "").replace(" ", "").toLowerCase() ===
      parts.join(" ").replace("_", "").replace(" ", "").toLowerCase()
  );
  return value ? value[valuePart] : false;
};

const ShareOptionsForm = ({
  handleSubmit,
  submitting,
  shareForm,
  edit,
  nextTab,
  isPhotographer,
  useMoveboothTheme,
  permissionRole,
  ...props
}) => {
  return (
    <StyledForm onSubmit={handleSubmit}>
      <ToastContainer />
      {formOptions.map((option, idx) => {
        return option.eligibleTiers.includes(permissionRole) ? (
          <FormSection
            key={idx}
            {...option}
            shareForm={shareForm}
            permissionRole={permissionRole}
            formDataOnChange={(value) =>
              props.changeFieldValue("share_types", value)
            }
          />
        ) : null;
      })}

      <Divider marginBottom={48}></Divider>
      <UpgradeText className="left-pos pdd-20">
        Looking for more? Send us a suggestion.
      </UpgradeText>
      <div className="channel-forms__group">
        {edit || isPhotographer || (!isPhotographer && useMoveboothTheme) ? (
          <Button type="submit" onClick={notify} disabled={submitting}>
            Save
          </Button>
        ) : (
          <Button type="button" onClick={() => nextTab()}>
            Save & continue
          </Button>
        )}
      </div>
    </StyledForm>
  );
};

const FormSection = ({
  header,
  description,
  fields,
  shareForm,
  permissionRole,
  formDataOnChange,
}) => {
  const requiredOptionAllowedTiers = [
    "plus",
    "pro",
    "super_admin",
    "enterprise_admin",
  ];
  const requiredEnabled = requiredOptionAllowedTiers.includes(permissionRole);
  return (
    <FormGroup className="sharing-form">
      <ChannelFormSection>
        <FieldHead className="brand">
          <strong>{header}</strong>
          <h3>{description}</h3>
        </FieldHead>
        {fields.map(
          (
            {
              name,
              label,
              description,
              requiredName,
              eligibleToRequireTiers,
              eligibleToCollect,
            },
            idx
          ) => {
            return (header === "Lead Data Capture" &&
              eligibleToCollect.includes(permissionRole)) ||
              header !== "Lead Data Capture" ? (
              <div key={idx}>
                <FieldHead className="sharing-field">
                  <div>
                    <strong>{label}</strong>
                    <h3>{description}</h3>
                    {requiredName &&
                    requiredEnabled &&
                    eligibleToRequireTiers.includes(permissionRole) ? (
                      <SharingRequiredField>
                        <Field
                          name={requiredName}
                          component={SharingFormField}
                          label="Required?"
                          type="checkbox"
                          checked={getFieldValue(shareForm, requiredName)}
                          formData={shareForm}
                          formDataOnChange={formDataOnChange}
                        />
                      </SharingRequiredField>
                    ) : null}
                  </div>
                  <div>
                    <Field
                      name={name}
                      component={SharingFormField}
                      label=""
                      type="switch"
                      checked={getFieldValue(shareForm, name)}
                      formData={shareForm}
                      formDataOnChange={formDataOnChange}
                    />
                  </div>
                </FieldHead>

                {permissionRole === "plus" &&
                  header === "Lead Data Capture" &&
                  idx === 1 && (
                    <div style={{ marginTop: "20px" }}>
                      <UpgradeButtonLinkContainer>
                        <UpgradeButtonLink href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to collect date of birth and ZIP code!" target="_blank" rel="noreferrer noopener">
                          Upgrade to collect date of birth and ZIP code
                        </UpgradeButtonLink>
                      </UpgradeButtonLinkContainer>
                    </div>
                  )}
                {permissionRole === "lite" &&
                  header === "Sharing from the App" &&
                  idx === 2 && (
                    <div style={{ marginTop: "20px" }}>
                      <UpgradeButtonLinkContainer>
                        <UpgradeButtonLink
                          href="mailto:sales@movebooth.com?&subject=Movebooth%20Account%20Upgrade%20Request&body=I'd Like to upgrade to collect more details or make any fields
                          required!" target="_blank" rel="noreferrer noopener"
                        >
                          Upgrade to collect more details or make any fields
                          required
                        </UpgradeButtonLink>
                      </UpgradeButtonLinkContainer>
                    </div>
                  )}
              </div>
            ) : null;
          }
        )}
      </ChannelFormSection>
    </FormGroup>
  );
};
const selector = formValueSelector("channelForm");
const mapStateToProps = (state) => {
  return {
    shareForm: selector(state, "share_types") || [
      { required: false, enabled: false, name: "twitter" },
      { required: false, enabled: false, name: "phone" },
      { required: false, enabled: false, name: "name" },
      { required: false, enabled: false, name: "zip code" },
      { required: false, enabled: false, name: "date of birth" },
      { required: false, enabled: false, name: "email" },
      { required: false, enabled: false, name: "gallery_email" },
      { required: false, enabled: false, name: "gallery_phone" },
      { required: false, enabled: false, name: "gallery_twitter" },
      { required: false, enabled: false, name: "gallery_facebook" },
      { required: false, enabled: false, name: "first_name" },
      { required: false, enabled: false, name: "last_name" },
    ],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFieldValue: (field, value) =>
      dispatch(change("channelForm", field, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareOptionsForm);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/ShareOptionsForm.js